/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkip2BackIcon32Regular = forwardRef('MediaUiASkip2BackIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 8.5c0-2.06-2.352-3.236-4-2L3 14V7a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0v-7l10 7.5c1.648 1.236 4 .06 4-2V18l10 7.5c1.648 1.236 4 .06 4-2v-15c0-2.06-2.352-3.236-4-2L17 14V8.5Zm-2.8-.4a.5.5 0 0 1 .8.4v15a.5.5 0 0 1-.8.4l-10-7.5a.5.5 0 0 1 0-.8l10-7.5Zm14 0a.5.5 0 0 1 .8.4v15a.5.5 0 0 1-.8.4l-10-7.5a.5.5 0 0 1 0-.8l10-7.5Z" })));
});
